// This is temporary solution and can be deleted after
// we stop setting email token as cookie from query params.
export function getUrlWithoutEmailToken(queryParams) {
    queryParams.delete('emailToken');
    const otherParams = queryParams.toString();
    const urlWithoutEmailToken = `${location.pathname}${otherParams ? `?${otherParams}` : ''}`;
    return urlWithoutEmailToken;
}
